<!-- DOC: https://bootstrap-vue.org/docs/components/form-select -->
<template>
  <ValidationProvider
    ref="inputValidation"
    :name="name"
    :rules="validate"
    :mode="validationMode"
    v-slot="{ errors, classes }"
  >
    <b-form-group
      :label="label"
      :label-size="size"
      :label-class="`font-weight-bold ${
        validate.required === true ||
        (typeof validate === 'string' && validate.search('required') !== -1)
          ? 'is-required'
          : ''
      }`"
      :class="classes"
    >
      <Multiselect
        :id="name"
        v-model="_value"
        :multiple="multiple"
        :placeholder="placeholder"
        :trackBy="trackBy"
        :options="options"
        :searchable="true"
        :internal-search="true"
        :select-label="selectLabel || $t('select_option')"
        :selected-label="selectedLabel || $t('selected')"
        :deselect-label="deselectLabel || $t('remove_option')"
        :tag-placeholder="tagLabel || $t('tag_label')"
        :disabled="disabled"
        :loading="loading"
        :custom-label="customLabel"
        :close-on-select="closeOnSelect"
        :taggable="taggable"
        @tag="tagAction"
        @select="onchange"
        @input="onclick"
      >
        <span slot="noOptions">{{ noOptions }}</span>
        <span slot="noResult">{{ noResult }}</span>
        <template
          v-if="compressSelectionLabel"
          slot="selection"
          slot-scope="{ values, isOpen }"
        >
          <span
            v-if="values.length &amp;&amp; !isOpen"
            class="multiselect__single"
          >
            <b>{{ values.length }}</b>
            {{ $tc('options_selected', values.length) }}
          </span>
        </template>
      </Multiselect>

      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="errors.length === 0"
      >
        {{ errors.join('. ') }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'InputMultiSelectComponent',
  components: { Multiselect },
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    onchange: {
      type: Function,
      required: false,
      default: () => {},
    },
    onclick: {
      type: Function,
      required: false,
      default: () => {},
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Seleccione una opción',
    },
    validate: {
      type: [String, Object],
      required: false,
      default: '',
    },
    trackBy: {
      type: String,
      default: 'url',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    compressSelectionLabel: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Object, Array],
      required: false,
      default: null,
    },
    customLabel: {
      type: Function,
      required: true,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'aggressive', // passive, lazy, eager (https://vee-validate.logaretm.com/v3/guide/interaction-and-ux.html#interaction-modes)
    },
    size: {
      type: String,
      required: false,
      default: '',
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    tagAction: {
      type: Function,
      default: () => {},
    },
    selectLabel: {
      type: String,
      required: false,
      default: '✚',
    },
    selectedLabel: {
      type: String,
      required: false,
      default: '✓',
    },
    deselectLabel: {
      type: String,
      required: false,
      default: '✖',
    },
    tagLabel: {
      type: String,
      default: null,
    },
    showErrorMessage: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    noOptions: {
      type: String,
      default: 'Sin información',
    },
    noResult: {
      type: String,
      default: 'Sin resultados en búsqueda',
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        if (value === null) {
          this.$emit('update:value', {})
          this.$emit('input', {})
        } else {
          this.$emit('update:value', value)
          this.$emit('input', value)
        }
      },
    },
  },
}
</script>

<style lang="scss">

// .multiselect__select:after {
//   content: url('../../assets/images/proximo.svg');
// }
.multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #1faeef;
    margin-top: 4px;
    border-color: #1faeef rgba(0,0,0,0) rgba(0,0,0,0);
    border-style: solid;
    border-width: 5px 5px 0;
    // content: url('../../assets/images/proximo.svg');
}

.multiselect__input {
  padding: 5px 0 0 5px;
}
.multiselect__tags {
  border: 1px solid #ced4da !important;
  padding: 5px 40px 0 7px;
  border-radius: 3px;
}
.multiselect__tag {
  margin-bottom: 2px;
  margin-top: 2px;
  padding: 5px 26px 5px 10px;
}
.multiselect__placeholder,
.multiselect__single {
  margin-bottom: 0px;
  padding-top: 5px;
}
</style>